/* eslint-disable react/jsx-no-useless-fragment */
import { Chevron, theme } from '@lmc/ui-kit'
import { NAMESPACE } from 'locale'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { Button, Text } from '@lmc/ui-kit/src/general'
import { serviceUserProfileConstants as supConstants } from 'locale/serviceUserProfile'
import { useRouter } from 'hooks/useRouter'
import { GeneralText } from '../styledComponents'
import { EditTooltip } from './EditTooltip'

type GeneralNeedsSectionProps = {
  needsText: string | undefined
  testId?: string
}

export const GeneralNeedsSection = ({
  needsText,
  testId,
}: GeneralNeedsSectionProps) => {
  const { t } = useTranslation(NAMESPACE.SERVICE_USER_PROFILE)

  const router = useRouter()

  return (
    <CoreSectionWrapper
      data-testid={
        testId ? `${testId}-needs-section` : 'resident-needs-section'
      }
    >
      <CoreSection
        data-testid={testId ? `${testId}-needs-info` : 'resident-needs-info'}
      >
        <StyledCoreLabel
          level={2}
          data-testid={
            testId ? `${testId}-needs-label` : 'resident-needs-label'
          }
        >
          {t(supConstants.NEEDS)}
        </StyledCoreLabel>
        <GeneralText
          weight="bold"
          data-testid={
            testId ? `${testId}-needs-value` : 'resident-needs-value'
          }
        >
          <EditTooltip title={t(supConstants.NEEDS_TOOLTIP)}>
            <>{needsText}</>
          </EditTooltip>
        </GeneralText>
      </CoreSection>
      <CoreSection
        data-testid={
          testId ? `${testId}-needs-actions` : 'resident-needs-actions'
        }
      >
        <Button
          variant="text"
          onClick={() =>
            router.navigate(`/residents/${router?.params?.id}/needs`)
          }
          data-testid={
            testId
              ? `${testId}-needs-details-button`
              : 'resident-needs-details-button'
          }
        >
          {t(supConstants.VIEW_NEEDS_DETAILS)}
          <Chevron direction="right" color={theme.color.status.primary} />
        </Button>
      </CoreSection>
    </CoreSectionWrapper>
  )
}

const StyledCoreLabel = styled(Text)`
  color: ${(props) => props.theme.color.neutral.color5};
`

const CoreSectionWrapper = styled.div`
  border-top: 1px solid;
  border-color: ${(props) => props.theme.color.neutral.color7};
  margin-top: 16px;
  padding-top: 16px;
  display: flex;
  justify-content: space-between;
  ${({ theme }) => theme.mediaQueries.mobileDown} {
    flex-direction: column;
  }
`

const CoreSection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  ${({ theme }) => theme.mediaQueries.mobileDown} {
    margin-top: 15px;
  }
`
